module.exports = __webpack_public_path__ + "img/Dashboard-group.a63a405a.svg";